export const templates = [
  {
    title: 'токен 1',
    description: 'описание 1',
    content: '{token1}',
  },
  {
    title: 'токен 2',
    description: 'описание 2',
    content: '{token2}',
  },
  {
    title: 'сегмент 1',
    description: 'описание 3',
    content: '[segment-1]',
  },
  {
    title: 'сегмент 2',
    description: 'описание 4',
    content: '[segment-2]',
  },
];

export default templates;
